(function () {
  const MODULE_ID = 'hue-mini-review-module';

  function init() {
    if (document.getElementById(MODULE_ID)) return;

    const accordions = document.querySelector(
      '.oddit-section-main-product__accordions'
    );

    if (!accordions) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'oddit-section-main-product__hue-module';

    wrapper.innerHTML = `
      <div id="${MODULE_ID}"></div>
    `;

    accordions.parentNode.insertBefore(wrapper, accordions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor / AJAX rerenders support
  document.addEventListener('shopify:section:load', init);
})();
